import React from 'react';
import Brand from './Brand';
import Menu from './Menu';
import './TopBar.css';

export default () => (
  <div className="top-bar">
    <div className="top-bar-content">
      <Brand type="logo" isLink={true} />
      <Menu />
    </div>
  </div>
);



// WEBPACK FOOTER //
// ./src/components/TopBar.js